module.exports = __webpack_public_path__ + "img/hof_6.16b34018.jpg";